<script lang="ts">
import { useManualStore } from '@/stores/manualStore.ts'
import { storeToRefs } from 'pinia'
import { computed, ComputedRef } from 'vue'
import { useDesignStore } from '@/stores/designStore.ts'
import { BPopover } from 'bootstrap-vue-next'
import ToggleableValueButton from './ToggleableValueButton.vue'

interface Line {
  sections: string[]
  sectionDisplayType: string[] //toggleable | definition | normal
  lineDisplayAsBulleted: boolean
}

interface TextObject {
  [key: number]: Line
}
export default {
  props: ['text', 'spellgroups', 'perks', 'definitionHelp', 'title', 'calcOn'],
  setup(props, context) {
    const textObject: ComputedRef<TextObject> = computed(() => {
      let sections = props.text.split('\\n')
      let ret: TextObject = {}

      if (sections.length === 1) {
        sections = props.text.split('\n')
      } else {
        for (let i = 1; i < sections.length; i++) {
          sections[i] = '*' + sections[i]
        }
      }
      ret = getBaseTextObject(sections)
      if (props.definitionHelp) {
        Object.keys(ret).forEach((lineNum) => {
          let split = splitTextIntoDescriptions(ret[lineNum].sections)
          ret[lineNum].sections = split.sections
          ret[lineNum].sectionDisplayType = split.sectionDisplayType
        })
      }
      if (props.calcOn && props.spellgroups && Object.values(props.spellgroups).length > 0) {
        Object.keys(ret).forEach((lineNum) => {
          let split = replaceRank(ret[lineNum].sections, ret[lineNum].sectionDisplayType)
          ret[lineNum].sections = split.sections
          ret[lineNum].sectionDisplayType = split.sectionDisplayType
        })
      }
      if (props.calcOn && props.perks && props.perks.length > 0) {
        Object.keys(ret).forEach((lineNum) => {
          let split = replacePerkRank(ret[lineNum].sections, ret[lineNum].sectionDisplayType)
          ret[lineNum].sections = split.sections
          ret[lineNum].sectionDisplayType = split.sectionDisplayType
        })
      }

      return ret
    })
    const manualStore = useManualStore()

    const { rulesReference } = storeToRefs(manualStore)
    const protectedWordMap = computed(() => {
      let ret = {}
      let protectedWords: string[] = []
      Object.values(rulesReference.value).forEach((rule: any) => {
        if (rule.type != 'special') {
          ret[rule.title] = rule
          protectedWords.push(rule.title)
          if (rule.hoverAltText && rule.hoverAltText.length > 0) {
            rule.hoverAltText.forEach((text) => {
              ret[text] = rule
              protectedWords.push(text)
            })
          }
        }
      })
      return { rules: ret, protectedWords: protectedWords }
    })

    const designStore = useDesignStore()

    function getBaseTextObject(sections: string[]) {
      let textObj: TextObject = {}
      let i = 0
      sections.forEach((section) => {
        if (section[0] === '*') {
          textObj[i] = {
            sections: [section.substring(1)],
            lineDisplayAsBulleted: true,
            sectionDisplayType: ['normal']
          }
          i++
        } else {
          textObj[i] = {
            sections: [section],
            lineDisplayAsBulleted: false,
            sectionDisplayType: ['normal']
          }
          i++
        }
      })
      return textObj
    }
    function matchesWord(keyword, text, start) {
      if (start > 0) {
        if (text[start - 1] === ' ' || text[start - 1] === '(') {
          if (keyword.length < text.length - start) {
            if (
              text[start + keyword.length] === ' ' ||
              text[start + keyword.length] === '.' ||
              text[start + keyword.length] === ',' ||
              text[start + keyword.length] === '!' ||
              text[start + keyword.length] === ')' ||
              text[start + keyword.length] === ';'
            ) {
              return true
            }
          } else {
            return true
          }
        }
      } else {
        if (keyword.length < text.length - start) {
          if (
            text[start + keyword.length] === ' ' ||
            text[start + keyword.length] === '.' ||
            text[start + keyword.length] === ',' ||
            text[start + keyword.length] === '!' ||
            text[start + keyword.length] === ')' ||
            text[start + keyword.length] === ';'
          ) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    }
    const maxRank: ComputedRef<number> = computed((): number => {
      const groups: any = Object.values(props.spellgroups)

      let max = 0
      groups.forEach((group) => {
        let spell: any = Object.values(group.spells).reduce((a: any, b: any) =>
          a.rank - b.rank > 0 ? a : b
        )

        if (spell.rank > max) {
          max = spell.rank
        }
      })

      return max
    })
    const maxPerkRank = props.perks
      ? props.perks.reduce((acc: number, perk: any) => (perk.rank > acc ? perk.rank : acc), 0)
      : 0

    function perkValueDisplay(savedVal, rank: number) {
      let x = 0
      x = rank
      let addition = 0
      if (savedVal.includes('+')) {
        addition = parseInt(savedVal.substring(0, savedVal.indexOf('+')))
      }
      if (savedVal.includes('d')) {
        let val = savedVal.indexOf('d') - 1
        return addition + val * rank + savedVal.substring(savedVal.indexOf('d'))
      } else {
        return addition + rank
      }
    }
    function valueDisplay(savedVal, savedEnding, rank) {
      console.log(savedVal)
      let x = 0
      x = rank
      let addition = 0
      if (savedVal.includes('+')) {
        addition = parseInt(savedVal.substring(0, savedVal.indexOf('+')))
      }
      if (savedVal.includes('/')) {
        return (
          Math.floor(
            x / parseInt(savedVal.substring(savedVal.indexOf('/') + 1, savedVal.indexOf(')')))
          ) +
          addition +
          savedEnding
        )
      }

      if (savedVal.includes('*')) {
        return (
          x * parseInt(savedVal.substring(0, savedVal.indexOf('*'))) ||
          x * parseInt(savedVal.substring(savedVal.indexOf('*') + 1, savedVal.indexOf(')'))) +
            addition +
            savedEnding
        )
      }
      if (savedVal.includes('x')) {
        return (
          x * parseInt(savedVal.substring(0, savedVal.indexOf('x'))) ||
          x * parseInt(savedVal.substring(savedVal.indexOf('x') + 1, savedVal.indexOf(')'))) +
            addition +
            savedEnding
        )
      }
      return x + savedEnding
    }
    function replacePerkRank(sections, sectionDisplayType) {
      let sectionsRet = [...sections]
      let sectionDisplayTypeRet = [...sectionDisplayType]
      for (let i = 0; i < sectionsRet.length; i++) {
        if (sectionDisplayTypeRet[i] === 'normal') {
          if (sectionsRet[i].indexOf('/P') >= 0) {
            let end: number = sectionsRet[i].indexOf('/P') + 2
            let start: number = sectionsRet[i].indexOf('/P') - 1
            let dCount = 0
            for (
              let j = start;
              ((sectionsRet[i].charAt(j) === 'd' && dCount === 0) ||
                sectionsRet[i].charCodeAt(j) < 100) &&
              j >= 0;
              j--
            ) {
              console.log(sectionsRet[i].charAt(j))
              if (sectionsRet[i].charAt(j) === 'd') dCount++
              start--
            }
            start++
            let savedVal = sectionsRet[i].substring(start, end)
            if (start > 0 && end > 0) {
              let text = sectionsRet[i]
              sectionsRet[i] = text.substring(0, start)
              console.log(sectionsRet)

              sectionsRet.splice(
                i + 1,
                0,
                savedVal +
                  ':' +
                  perkValueDisplay(savedVal.substring(0, savedVal.length - 2), maxPerkRank),
                text.substring(start + savedVal.length)
              )
              console.log(sectionsRet)
              sectionDisplayTypeRet.splice(i + 1, 0, 'toggleable', 'normal')
            }
          }
        }
      }
      return { sections: sectionsRet, sectionDisplayType: sectionDisplayTypeRet }
    }

    function replaceRank(sections, sectionDisplayType) {
      let sectionsRet = [...sections]
      let sectionDisplayTypeRet = [...sectionDisplayType]

      for (let i = 0; i < sectionsRet.length; i++) {
        if (sectionDisplayTypeRet[i] === 'normal') {
          if (sectionsRet[i].indexOf('(Rank') >= 0 || sectionsRet[i].indexOf('(Spell ') > 0) {
            let start: number = sectionsRet[i].indexOf('(Rank')
            let end: number =
              sectionsRet[i].indexOf('d', start) > -1 &&
              sectionsRet[i].indexOf('d', start) - sectionsRet[i].indexOf(')', start) < 3
                ? sectionsRet[i].indexOf(' ', sectionsRet[i].indexOf('d', start))
                : sectionsRet[i].indexOf(')', start) + 1
            if (
              sectionsRet[i].indexOf('* (Rank)') > 0 &&
              start - sectionsRet[i].indexOf('* (Rank') <= 3 &&
              sectionsRet[i].indexOf('* (Rank') < start
            ) {
              start = sectionsRet[i].indexOf('* (Rank)')
              start -= 1
              start = sectionsRet[i].substring(0, start).lastIndexOf(' ') + 1
            }
            if (
              sectionsRet[i].indexOf('+ (Rank') > 0 &&
              start - sectionsRet[i].indexOf('+ (Rank') <= 3 &&
              sectionsRet[i].indexOf('+ (Rank') < start
            ) {
              start = sectionsRet[i].indexOf('+ (Rank')
              start -= 1
              start = sectionsRet[i].substring(0, start).lastIndexOf(' ') + 1
              // end = text.indexOf(' ', text.indexOf(')', start))
            }
            if (sectionsRet[i].indexOf(")'") > 0) {
              end = sectionsRet[i].indexOf(")'") + 2
            }
            if (end + 1 == sectionsRet[i].length) {
              end = sectionsRet[i].indexOf(')', start) + 1
            }
            if (sectionsRet[i].indexOf('(Rank)') > 0 && sectionsRet[i].indexOf('(Rank)') < start) {
              start = sectionsRet[i].indexOf('(Rank)')
              end = sectionsRet[i].indexOf(')', start) + 1
            }
            let savedEnding = sectionsRet[i].substring(sectionsRet[i].indexOf(')', start) + 1, end)
            let savedVal = sectionsRet[i].substring(start, end)
            if (start > 0 && end > 0) {
              let text = sectionsRet[i]
              sectionsRet[i] = text.substring(0, start)
              console.log(sectionsRet)

              sectionsRet.splice(
                i + 1,
                0,
                savedVal + ':' + valueDisplay(savedVal, savedEnding, maxRank.value),
                text.substring(start + savedVal.length)
              )
              console.log(sectionsRet)
              sectionDisplayTypeRet.splice(i + 1, 0, 'toggleable', 'normal')
            }
          }
        }
      }
      return { sections: sectionsRet, sectionDisplayType: sectionDisplayTypeRet }
    }
    function splitTextIntoDescriptions(sections: string[]) {
      let ret: string[] = []
      let retType: string[] = []

      sections.forEach((text) => {
        let foundWords = protectedWordMap.value.protectedWords.filter((word) => text.includes(word))
        let orderedWordsObj = {}
        foundWords.forEach((word) => {
          let start = 0
          while (text.indexOf(word, start) >= 0) {
            const index = text.indexOf(word, start)
            orderedWordsObj[index] = word
            start = index + word.length
          }
        })
        let orderedWordsArray = Object.keys(orderedWordsObj)
          .sort((a, b) => parseInt(a) - parseInt(b))
          .map((key) => orderedWordsObj[key])

        orderedWordsArray.forEach((word) => {
          let start = text.indexOf(word)
          if (!matchesWord(word, text, start)) {
            ret.push(text.substring(0, start + word.length))
            retType.push('normal')
            text = text.substring(start + word.length)
          } else {
            if (start > 0) {
              ret.push(text.substring(0, start))
              retType.push('normal')
            }
            ret.push(text.substring(start, start + word.length))
            retType.push('definition')
            text = text.substring(start + word.length)
          }
        })

        ret.push(text)
        retType.push('normal')
      })
      return { sections: ret, sectionDisplayType: retType }
    }
    return { textObject, designStore, rulesReference, protectedWordMap }
  },
  components: { BPopover, ToggleableValueButton }
}
</script>
<template>
  <div>
    <div v-for="num in Object.keys(textObject)" style="display: flex" :key="num">
      <li
        style="
          padding-left: 1rem;
          margin-bottom: 0.25rem;
          list-style-type: none;
          text-indent: -1rem;
        "
        v-if="textObject[num].lineDisplayAsBulleted"
      >
        {{ '❖ ' }}
        <span v-for="(section, index) in textObject[num].sections" :key="index">
          <span v-if="textObject[num].sectionDisplayType[index] === 'normal'">{{ section }}</span>
          <span v-if="textObject[num].sectionDisplayType[index] === 'toggleable'"
            ><ToggleableValueButton
              :val1="section.split(':')[0]"
              :val2="section.split(':')[1]"
            ></ToggleableValueButton
          ></span>
          <span
            v-if="textObject[num].sectionDisplayType[index] === 'definition'"
            :id="'definition' + num + index + title"
          >
            <BPopover
              :style="{
                background: designStore.inputBacking,
                borderColor: designStore.secondaryTheme,
                color: designStore.inputText
              }"
              class="popover"
              :close-on-hide="true"
              :delay="{ show: 0, hide: 0 }"
              style="width: fit-content !important; text-indent: 0rem"
              :placement="'top'"
              :target="num + index + 'def' + title"
            >
              <template #target>
                <span
                  class="hoverableText"
                  style="font-style: italic; cursor: pointer"
                  :id="num + index + 'def' + title"
                  >{{ section }}</span
                >
              </template>
              <div
                :style="{
                  color: designStore.inputText
                }"
              >
                {{ protectedWordMap.rules[section]?.hoverDescription || 'oopsie' }}
              </div>
            </BPopover>
          </span>
        </span>
      </li>
      <div style="margin-bottom: 0.25rem; list-style-type: none" v-else>
        <span v-for="(section, index) in textObject[num].sections" :key="index">
          <span v-if="textObject[num].sectionDisplayType[index] === 'normal'">{{ section }}</span>
          <span v-if="textObject[num].sectionDisplayType[index] === 'toggleable'"
            ><ToggleableValueButton
              :val1="section.split(':')[0]"
              :val2="section.split(':')[1]"
            ></ToggleableValueButton
          ></span>
          <span
            v-if="textObject[num].sectionDisplayType[index] === 'definition'"
            :id="'definition' + num + index + title"
          >
            <BPopover
              :style="{
                background: designStore.inputBacking,
                borderColor: designStore.secondaryTheme,
                color: designStore.inputBacking
              }"
              class="popover"
              :close-on-hide="true"
              :delay="{ show: 0, hide: 0 }"
              style="width: fit-content !important"
              :placement="'top'"
              :target="num + index + 'def' + title"
            >
              <template #target>
                <span
                  class="hoverableText"
                  style="font-style: italic; cursor: pointer"
                  :id="num + index + 'def' + title"
                  >{{ section }}</span
                >
              </template>
              <div
                :style="{
                  color: designStore.inputText
                }"
              >
                {{ protectedWordMap.rules[section]?.hoverDescription || 'oopsie' }}
              </div>
            </BPopover>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<style></style>
